

















































import { computed, defineComponent, PropType } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { ProcessingStatus } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { MediaFilesController } from "@/lib/MediaFilesController";
import AudioPlayerController from "@/components/AudioPlayerController";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";
import InputRange from "@/components/BaseInputs/InputRange";
import BaseSpinner from "@/components/BaseSpinner";
import GlobalAudioPlayerController from "@/components/GlobalAudioPlayer/components/GlobalAudioPlayerController.vue";
import { GlobalAudioPlayerFileState } from "@/components/GlobalAudioPlayer/types";

export default defineComponent({
  name: "AudioPlayer",
  components: { InputRange, BaseImage, BaseIcon, BaseSpinner, AudioPlayerController, GlobalAudioPlayerController },
  props: {
    file: { type: Object as () => FileData | ContentFile, required: true },
    isAvailable: { type: Boolean, default: true },
    global: { type: Boolean, default: false },
    globalState: { type: Object as PropType<GlobalAudioPlayerFileState> },
    active: { type: Boolean, default: false },
    processingStatus: { type: String as () => ProcessingStatus, required: true },
  },
  setup(props) {
    const audioSrc = computed(() => (props.file.urlPart ? MediaFilesController.getFileUrl(props.file.urlPart) : ""));
    const isShowDuration = computed(() => props.processingStatus === "OK");
    const processingError = computed(() => props.processingStatus === "ERROR");
    const isSpinnerShow = computed(() => props.processingStatus !== "OK" && !processingError.value);

    const inputFillLower = "var(--palette-gray-darken-4)";
    const inputFillUpper = "var(--palette-gray-lighten-4)";

    return {
      audioSrc,
      isShowDuration,
      processingError,
      isSpinnerShow,
      inputFillLower,
      inputFillUpper,
    };
  },
});
